import { IGridViewConfig } from './typings';

const config: IGridViewConfig = {
  data: {},
  card: undefined,
  items: { items: [] },
  mayCustom: false,
  showPager: false,
  showOrdinal: true,
  showSummary: false,
  collapseMenu: false,
  rowSelection: false,
  orderby: [],
  fastnessCount: 0,
  isAutoSelection: false,
  rowSelectionType: 'checkbox',
  buttons: undefined,
  modifyMode: undefined,
  displayMode: undefined,
  disabledMode: undefined,
};

export default config;
